import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface MigrationDialogData {
  oldValue: string;
  count: number;
  targets: string[];
}

@Component({
  selector: 'app-requirement-status-migration-dialog',
  imports: [FormsModule, TranslatePipe, MatButtonModule],
  templateUrl: './requirement-status-migration-dialog.component.html',
  styleUrl: './requirement-status-migration-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequirementStatusMigrationDialogComponent {
  readonly data = inject<MigrationDialogData>(MAT_DIALOG_DATA);
  private readonly ref = inject<MatDialogRef<RequirementStatusMigrationDialogComponent, string | null>>(MatDialogRef);

  readonly selectedTarget = signal<string>(this.data.targets[0] ?? '');

  onTargetChange(next: string): void {
    this.selectedTarget.set(next);
  }

  cancel(): void {
    this.ref.close(null);
  }

  confirm(): void {
    const target = this.selectedTarget();
    if (!target) {
      this.ref.close(null);
      return;
    }
    this.ref.close(target);
  }
}
